module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Oops, an error occurred!":"Es ist ein Fehler aufgetreten!","Reset password":"Passwort zurücksetzen","New password":"Neues Passwort","Cancel":"Abbrechen","Save the new password and login":"Neues Passwort speichern und einloggen"}}')
  delete Component.options._Ctor
}
